import Route from '@ember/routing/route'
import { service } from '@ember/service'
import type RouterService from '@ember/routing/router-service'
import type FeaturesService from 'teacher-ui-client/services/features'
import type { SubscriptionType } from 'teacher-ui-client/subscription-type/subscription-types'

interface TeacherHomeRouteModel {
  subscriptionType: SubscriptionType
}

export class TeacherHomeRoute extends Route {
  @service router!: RouterService
  @service features!: FeaturesService

  beforeModel() {
    if (!this.features.isEnabled('tui_teacher_home')) {
      void this.router.replaceWith('subscription-type.home')
    }
  }

  model(): TeacherHomeRouteModel {
    const { subscriptionType } = this.modelFor('subscription-type') as ModelForSubscriptionTypeRoute
    return { subscriptionType }
  }
}

export default TeacherHomeRoute
